<template>
  <div class="card">
    <div class="card__side card__side--front">
      <div class="card__image-box">
        <img
          :src="cardImage"
          alt="Logo"
          class="card__image"
        />
      </div>
      <h4 class="card__heading">
        <span class="card__heading-span card__heading-span--1">
          {{ this.cardText }}
        </span>
      </h4>
    </div>
    <div class="card__side card__side--back">
      <div class="card__cta">
        <div class="card__details-box">
          <p class="card__details-value">
            Flash floods are among the world’s deadliest natural hazards. They
            are sudden and short and have enough power to change the course of
            rivers, bury houses in mud, and sweep away or destroy whatever
            stands in their path in less than six hours. They are complex
            hydrometeorological events that are hard to predict. Therefore,
            preparing for them requires expertise in hydrology and meteorology
            combined with knowledge of local conditions.
          </p>
        </div>
        <Button
          buttonText="Start Simulator"
          buttonSize="sm"
          animated="false"
          green="true"
          action="#stepper-popup"
          @click.native="writeSelectedRegionToState"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Button from "./Button.vue";

export default {
  props:["cardImage","cardText","region"],
  components: {
    Button,
  },
  methods: {
    writeSelectedRegionToState() {
      console.log("Assigning region to state")
      this.assignSelectedRegion(this.region);
      this.writeDefaultSelectedRegionNavigationOption(this.region)
    },
    writeDefaultSelectedRegionNavigationOption(region){
      console.log("Writing default navigation option to state")
      loop: for(let i = 0; i < region.navigation.length; i++){
        let navigation = region.navigation[i];
        for (let j = 0; j < navigation.options.length; j++) {
          let firstNavigationOption = navigation.options[j];
          this.assignSelectedNavigationOption(firstNavigationOption);
          break loop;
        }
      }
    },
    ...mapMutations([
      "assignSelectedRegion",
      "assignSelectedNavigationOption"
    ]),
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.card {
  perspective: 150rem;
  -moz-perspective: 150rem;
  position: relative;
  height: 30rem;
  width: 30rem;
  margin-bottom: 2rem;
  margin-right: 2rem;
  z-index: 10;
  transition: all 1.5s ease;

  &__side {
    color: $color-black;
    font-size: 2rem;
    height: inherit;
    width: inherit;
    transition: all 1.5s ease;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4rem;
    box-shadow: rgb(38, 57, 77) 0rem 2rem 3rem -1rem;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;

    &--front {
      background-color: $color-white;
    }

    &--back {
      transform: rotateY(180deg);
      background-image: linear-gradient(
        to right bottom,
        $color-primary-light,
        $color-primary-dark
      );
    }
  }

  &:hover &__side--front {
    transform: rotateY(-180deg) scale(1.5, 1.5);
  }

  &:hover &__side--back {
    transform: rotateY(0) scale(1.5, 1.5);
  }

  &:hover {
    z-index: 20;
  }

  //FRONT SIDE STYLING
  &__image-box {
    height: 100%;
  }

  &__image {
    width: 100%;
    height: 100%;
    background-size: cover;
    border-radius: 4rem;
  }

  &__heading {
    font-size: 2rem;
    font-weight: 300;
    text-transform: uppercase;
    text-align: right;
    color: $color-white;
    position: absolute;
    top: 12rem;
    right: 2rem;
    width: 75%;
  }

  &__heading-span {
    padding: 1rem 1.5rem;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    background-image: linear-gradient(
      to right bottom,
      rgba($color-secondary-light, 0.85),
      rgba($color-secondary-dark, 0.85)
    );
  }

  //BACK SIDE STYLING
  &__cta {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    width: 90%;
    text-align: center;
    height: 100%;
  }

  &__details-box {
    height: 50%;
    padding: 0.5rem;
    text-align: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
  }

  &__details-value {
    font-size: 1rem;
    font-weight: 100;
    color: $color-white;
  }
}
</style>
